/** Local wall time in the shape <input type="datetime-local"> expects. */
export function toDateTimeLocal(date: Date): string {
  const pad = (n: number) => String(n).padStart(2, "0");
  return (
    `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}` +
    `T${pad(date.getHours())}:${pad(date.getMinutes())}`
  );
}

/**
 * An API datetime (e.g. "2026-08-12T10:00:00.000Z") as a datetime-local value.
 * Empty when missing or unparseable, which leaves the input blank rather than
 * holding a value it cannot show.
 */
export function isoToDateTimeLocal(value?: string): string {
  if (!value) return "";
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? "" : toDateTimeLocal(d);
}
